export function getBirthdateLimit() {
  // calculate min and max date for birthdate. Min 13 years old, max 200 years old. Must be in yyyy-mm-dd

  const minDate = new Date()
  minDate.setFullYear(minDate.getFullYear() - 13)
  const maxDate = new Date()
  maxDate.setFullYear(maxDate.getFullYear() - 200)

  return {
    minDate: minDate.toISOString().split('T')[0],
    maxDate: maxDate.toISOString().split('T')[0],
  }
}
